export default __webpack_public_path__ + "static/media/bookingClose.679f20b7.svg";